import React from 'react'
import ConsultaRemessaPagamentoFormPageContainer from './ConsultaRemessaPagamentoFormPageContainer'

export class ConsultaRemessaPagamentoFormPage extends React.Component {
  render() {
    return <ConsultaRemessaPagamentoFormPageContainer {...this.props} />
  }
}
